import { isAxiosError } from "axios";

export enum LoginErrorVariants {
    NONE = "none",
    INVALID_CODES = "invalidCodes",
    TRANSIENT = "transient",
}

/** Axios 4xx: the backend turned the request down, so retrying it unchanged won't help. */
export const isClientError = (e: unknown): boolean => {
    const status = isAxiosError(e) ? e.response?.status ?? 0 : 0;
    return status >= 400 && status < 500;
};

export const loginErrorVariantFromError = (e: unknown): LoginErrorVariants =>
    isClientError(e) ? LoginErrorVariants.INVALID_CODES : LoginErrorVariants.TRANSIENT;
